import { dateFormatters } from './formattersV2';

export const parseReportDateToLocaleFormat = (date: string) => {
  const parsedDate = new Date(date);

  return dateFormatters.shortLocaleString(parsedDate);
};

export const dateRangeToString = (dateRange: [string, string]): string =>
  dateRange
    .map(date => dateFormatters.shortLocaleString(new Date(date)))
    .join(' - ');
